import { GetYesterdayBriefing, GetYesterdayShops, YesterdayCustomer } from "@/api/YesterdayBriefing";

const state = {
    GetYesterdayBriefing: null, //单/多店铺数据
    GetYesterdayShops: [], //模板消息的多店铺名称
    YesterdayCustomer: {}, //昨日客户/客户类型
};

const mutations = {
    SET_DATA: (state, { key, data }) => {
        state[key] = data;
    },
    INIT_ShopsList: (state, data) => {
        state.GetYesterdayShops = data
    },
};

const actions = {
    //单/多店铺数据
    GetYesterdayBriefing({ commit },params) {
        return new Promise((resolve) => {
            GetYesterdayBriefing(params).then(res => {
                commit("SET_DATA", { key: 'GetYesterdayBriefing', data: res.data });
                resolve(res.data)
            })
        })
    },
    //模板消息的多店铺名称
    GetYesterdayShops({ commit }, params) {
        return new Promise((resolve) => {
            GetYesterdayShops(params).then(res => {
                commit("SET_DATA", { key: 'GetYesterdayShops', data: res.data.data });
                resolve(res.data)
            })
        })
    },
    // 昨日客户/客户类型
    YesterdayCustomer({ commit }, params) {
        return new Promise((resolve) => {
            YesterdayCustomer(params).then(res => {
                commit("SET_DATA", { key: 'YesterdayCustomer', data: res.data.data });
                resolve(res.data)
            })
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
